import React from 'react';
import { withStyles, Grid } from '@material-ui/core';
import Button from '../controls/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepperDeleteIcon from '../controls/StepperDeleteIcon';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import PublishIcon from '@material-ui/icons/Publish';
import clsx from 'clsx';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LinkIcon from '@material-ui/icons/Link';

const styles = (theme) => ({
    actionBar: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },

    addStepButton: {
        minWidth: 0,
        left: -theme.spacing(1),
        padding: '4px 8px 4px 8px',
    },
    sectionsHeader: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2),
    },
    singleStep: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    stepText: {
        textAlign: 'left',
        padding: theme.spacing(1.5, 0),
        width: '100%',
    },
    clickableStepText: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgb(189, 189, 189, 0.1)',
        },
    },
    stepper: {
        padding: '24px 0px 24px 0px',
    },
    stepperContainer: {
        whiteSpace: 'normal',
    },
    drag: {
        backgroundColor: 'rgb(189, 189, 189, 0.1)',
    },
    linkIcon: {
        color: '#757575',
    },
});

class StepperPanel extends React.Component {
    state = {
        stepHoveredOver: undefined,
    };

    handleMouseEnter = (index) => {
        this.setState({
            stepHoveredOver: index,
        });
    };

    handleMouseLeave = () => {
        this.setState({
            stepHoveredOver: undefined,
        });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        let sections = [...this.props.sections];
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }
        const section = sections[source.index];
        sections.splice(source.index, 1);
        sections.splice(destination.index, 0, section);
        this.props.handleSectionsReorder(sections);
        this.updateActiveSection(source.index, destination.index, sections);
    };

    updateActiveSection = (source, destination, sections) => {
        if (this.isEmbeddedFormStep(destination, sections)) {
            if (this.props.currStep < source && this.props.currStep >= destination) {
                this.props.handleStepChange(this.props.currStep + 1);
            } else if (this.props.currStep > source && this.props.currStep <= destination) {
                this.props.handleStepChange(this.props.currStep - 1);
            }
        } else {
            this.props.handleStepChange(destination);
        }
    };

    isEmbeddedFormStep = (index, sections) => {
        sections = sections ?? this.props.sections;
        return sections[index].form && this.props.stepType === 'Section';
    };

    render() {
        const leftPanelOpen = this.props.isOpened;
        return (
            <React.Fragment>
                {this.props.isOpened ? (
                    <Typography variant="h6" className={this.props.classes.sectionsHeader} color="primary">
                        Sections
                    </Typography>
                ) : (
                    <FormatListBulletedIcon className={this.props.classes.sectionsHeader} color="primary" />
                )}

                <div className={this.props.classes.stepperContainer}>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        {this.props.steps.length > 0 && (
                            <Droppable droppableId="stepsDroppable">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        <Stepper
                                            className={this.props.classes.stepper}
                                            activeStep={this.props.currStep}
                                            orientation="vertical"
                                            nonLinear
                                            connector={null}
                                        >
                                            {this.props.steps.map((section, index) => (
                                                <Draggable
                                                    key={`${section} ${index}`}
                                                    draggableId={`${section} ${index}`}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            className={clsx({
                                                                [this.props.classes.drag]: snapshot.isDragging,
                                                            })}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            ref={provided.innerRef}
                                                        >
                                                            <Step
                                                                className={this.props.classes.singleStep}
                                                                index={index}
                                                                active={this.props.currStep === index}
                                                                key={section}
                                                                onMouseEnter={() => this.handleMouseEnter(index)}
                                                                onMouseLeave={() => this.handleMouseLeave(index)}
                                                            >
                                                                <StepLabel
                                                                    onClick={
                                                                        !this.isEmbeddedFormStep(index)
                                                                            ? () => this.props.handleStepChange(index)
                                                                            : null
                                                                    }
                                                                    className={clsx(
                                                                        {
                                                                            [this.props.classes
                                                                                .clickableStepText]: !this.isEmbeddedFormStep(
                                                                                index,
                                                                            ),
                                                                        },
                                                                        this.props.classes.stepText,
                                                                    )}
                                                                    StepIconComponent={
                                                                        this.isEmbeddedFormStep(index)
                                                                            ? () => (
                                                                                  <LinkIcon
                                                                                      className={
                                                                                          this.props.classes.linkIcon
                                                                                      }
                                                                                  />
                                                                              )
                                                                            : null
                                                                    }
                                                                >
                                                                    {leftPanelOpen ? section : undefined}
                                                                </StepLabel>
                                                                {leftPanelOpen ? (
                                                                    <StepperDeleteIcon
                                                                        index={index}
                                                                        currStep={this.props.currStep}
                                                                        stepHoveredOver={this.state.stepHoveredOver}
                                                                        handleDeleteSection={
                                                                            this.props.handleDeleteSection
                                                                        }
                                                                    />
                                                                ) : undefined}
                                                            </Step>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </Stepper>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        )}
                    </DragDropContext>
                </div>

                <Grid container className={this.props.classes.actionBar} direction="column" spacing={1}>
                    <Grid item>
                        <Button
                            aria-label={'Add ' + this.props.stepType}
                            className={clsx({
                                [this.props.classes.addStepButton]: !leftPanelOpen,
                            })}
                            onClick={this.props.handleAddSection}
                            variant="contained"
                            size="small"
                            color="primary"
                            fullWidth
                        >
                            <AddIcon />
                            {leftPanelOpen ? `Add ${this.props.stepType}` : null}
                        </Button>
                    </Grid>
                    {this.props.stepType === 'Section' && (
                        <Grid item>
                            <Button
                                className={clsx({
                                    [this.props.classes.addStepButton]: !leftPanelOpen,
                                })}
                                variant="outlined"
                                color="primary"
                                size="small"
                                fullWidth
                                onClick={this.props.importForm}
                            >
                                <PublishIcon />
                                {leftPanelOpen ? 'Import Form' : null}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(StepperPanel);
